import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Game } from '../types';
import { games } from '../data/games';

export default function RecentPlayedList() {
  const [recentPlayed, setRecentPlayed] = useState<Game[]>([]);

  useEffect(() => {
    // 從 localStorage 獲取最近玩過的遊戲
    const recentPlayedIds = JSON.parse(localStorage.getItem('recentPlayed') || '[]');
    
    // 將 ID 轉換為完整的遊戲對象
    const recentGames = recentPlayedIds
      .map((item: any) => games.find(game => game.id === item.id))
      .filter((game: Game | undefined) => game !== undefined) as Game[];
    
    setRecentPlayed(recentGames);
  }, []);

  // 如果沒有最近玩過的遊戲，則不顯示此組件
  if (recentPlayed.length === 0) return null;

  return (
    <div className="mb-8">
      <h2 className="text-2xl font-bold text-white mb-6 flex items-center">
        <span className="w-1 h-6 bg-purple-500 mr-3"></span>
        Recently Played
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {recentPlayed.map((game) => (
          <Link
            key={game.id}
            to={`/game/${game.id}`}
            className="group relative block rounded-lg overflow-hidden bg-[#13111d] hover:scale-105 transition-transform duration-200"
          >
            <div className="relative w-full aspect-video overflow-hidden">
              <img
                src={game.thumbnails[0]}
                alt={game.title}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-4">
              <h3 className="text-lg font-semibold text-white mb-1">{game.title}</h3>
              <p className="text-gray-400 text-sm line-clamp-2">{game.description}</p>
            </div>
            <div className="absolute top-2 right-2 bg-blue-500 text-white text-xs px-2 py-1 rounded">
              {game.category}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
} 